import React from 'react';
import { Container, Row } from 'react-bootstrap';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import DefaultTabsBorderedBottom from './DefaultTabsBorderedBottom';
import RequestList from './RequestList';

const Request = () => (
  <div>
    <Container>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
        marginBottom: '5px',
      }}
      >
        <Typography sx={{ color: 'text.primary' }}>Admin</Typography>
        <Typography sx={{ color: 'text.primary' }}>Agent</Typography>
        <Typography sx={{ color: 'text.primary' }}>Request</Typography>
      </Breadcrumbs>
    </Container>
    <Container className="bg-white" style={{ padding: '20px' }}>
      
      <RequestList />
    </Container>
  </div>
  
  
);

export default Request;
